<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";
  import StarwoodPopup from "./StarwoodPopup.svelte";

  export let starwoodData = [];
  export let countiesVector;

  let mapsfr;
  let markers = [];
  let markersLayer;

  const yearColor = {
    2017: "#49F1FC",
    2018: "#EB5FC9",
    2019: "#11FA8A",
    2020: "#7289E6",
    2021: "#F59C46",
  };

  const countyPopupStyle = {
    fillOpacity: 0.5,
    fillColor: "lightgray",
    color: "white",
    weight: 0.6,
  };

  var mapboxAccessToken =
    "pk.eyJ1IjoiZ3JhY2Vnc3kiLCJhIjoiY2tpN3c3djh1NGxjZTJ4cm16bGdxNHI5ZCJ9.DD9X7XuTcY42PffpEqNo-g";

  onMount(() => {
    mapsfr = L.map("mapsfr", {
      minZoom: 9,
      maxZoom: 18,
    }).setView([33.740311278894275, -84.24605007039229], 13);
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 22,
        id: "mapbox/light-v9",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: mapboxAccessToken,
      }
    ).addTo(mapsfr);

    L.geoJSON(countiesVector, { style: countyPopupStyle })
      .bindPopup(({ feature }) => `<p>${feature.properties.NAME10}</p>`)
      .addTo(mapsfr);

    markersLayer = L.layerGroup(markers);
  });

  // From https://svelte.dev/repl/62271e8fda854e828f26d75625286bc3
  function bindPopup(marker, createFn) {
    let popupComponent;
    marker.bindPopup(() => {
      let container = L.DomUtil.create("div");
      popupComponent = createFn(container);
      return container;
    });

    marker.on("popupclose", () => {
      if (popupComponent) {
        let old = popupComponent;
        popupComponent = null;
        // Wait to destroy until after the fadeout completes.
        setTimeout(() => {
          old.$destroy();
        }, 500);
      }
    });
  }

  $: if (markersLayer && mapsfr) {
    markersLayer.clearLayers();
    // L.circle([33.738804152937604, -84.25008343069548], { // 4100 Glenwood
    L.circle([33.740311278894275, -84.24605007039229], {
      radius: 1610,
      color: "red",
    }).addTo(mapsfr);

    markers = [];
    for (let address of starwoodData) {
      let circle = L.circleMarker(address.coordinates, {
        radius: 4,
        weight: 2,
        fillOpacity: 1,
        // opacity: 0,
        fillColor: "#11FA8A",
        color: "#7289E6",
        // fillColor: yearColor[address.events[0]["fileDate"].slice(0, 4)],
      });
      bindPopup(circle, (marker) => {
        let c = new StarwoodPopup({
          target: marker,
          props: {
            address: address.address,
            origin: address.origin,
            // events: address.events,
          },
        });
        return c;
      });
      markers.push(circle);
    }

    markersLayer = L.layerGroup(markers);
    markersLayer.addTo(mapsfr);
  }
</script>

<div id="mapsfr" />

<style>
  #mapsfr {
    height: 70vh;
    width: auto;
    margin: 25px;
  }
</style>
